module.exports = __webpack_public_path__ + "img/mali.73e67ad4.svg";